import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styling/poCss/purchaseOrder.css";

const PoPrintHeader = ({ poData }) => {
  const location = useLocation();
  const [count, setCount] = useState("");
  const invoiceId = location.pathname.split("/")[2];

  return (
    <header>
      {/* Header */}
      <div className="invoice-header">Purchase Order</div>

      {/* ======= Company Section ======= */}
         <div className="company-section">
        <div className="logo-section">
          <div className="logo">
            <img
              src={poData?.poDetails?.company?.logoUrl}
              className="img-fluid"
              alt="Company Logo"
            />
          </div>
        </div>

        <div className="company-details">
          <div className="company-name">{poData?.poDetails?.company?.name}</div>
          <div className="company-info">
            {poData?.poDetails?.office?.address1}
            <br />
            {poData?.poDetails?.office?.address2}
            <br />
            {poData?.poDetails?.office?.address3}
            <br />
            {poData?.poDetails?.city?.description} -{" "}
            {poData?.poDetails?.office?.pincode}
          </div>
        </div>

        <div className="invoice-details">
          <ul className="invoice-lists">
            <li>
              <div className="invoice-item">
                <span className="invoice-label">GSTIN</span>
                <span>{poData?.poDetails?.office?.gstin}</span>
              </div>
            </li>
            <li>
              <div className="invoice-item">
                <span className="invoice-label">CIN NO.</span>
                <span>{poData?.poDetails?.company?.cinNumber}</span>
              </div>
            </li>
            <li>
              <div className="invoice-item">
                <span className="invoice-label">Company Code</span>
                <span>{poData?.poDetails?.company?.companyCode}</span>
              </div>
            </li>
            <li>
              <div className="invoice-item">
                <span className="invoice-label">Email</span>
                <span>{poData?.poDetails?.office?.emailId}</span>
              </div>
            </li>
            <li>
              <div className="invoice-item">
                <span className="invoice-label">P.O. No.</span>
                <span>
                  {poData?.poDetails?.invoice?.invoicePosted === "Yes"
                    ? poData?.poDetails?.invoice?.invoiceNumber
                    : invoiceId}
                </span>
              </div>
            </li>
            <li>
              <div className="invoice-item">
                <span className="invoice-label">P.O. Date</span>
                <span>
                  {poData?.poDetails?.purchaseOrder?.pO_Date
                    ? poData.poDetails.purchaseOrder.pO_Date
                        .split("T")[0]
                        .split("-")
                        .reverse()
                        .join("-")
                    : ""}
                </span>
              </div>
            </li>
            <li>
              <div className="invoice-item">
                <span className="invoice-label">Status</span>
                <span>Released</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {/* ======= Supplier & Delivery Section ======= */}
      <div className="po-supplier-delivery-section">
        {/* Supplier Block */}
        <div className="po-supplier-block">
          <div className="po-section-title">SUPPLIER DETAILS</div>
          <div>
            <b>{poData?.poDetails?.vendor?.name}</b>
          </div>
          <div>
            {poData?.poDetails?.vendor?.address1},{" "}
            {poData?.poDetails?.vendor?.address2}
            <br />
            {poData?.poDetails?.vendor?.address3}{" "}
            {poData?.poDetails?.vendor?.pincode}
          </div>
          <br />
          <div>
            <span className="label">GSTIN</span>
            <span>
              :{" "}
              {poData?.poDetails?.vendor?.gstno ??
                poData?.poDetails?.customer?.taxId}
            </span>

            {poData?.poDetails?.vendor?.pan !== "" && (
              <div>
                <span className="label">PAN</span>
                <span>: {poData?.poDetails?.vendor?.pan}</span>
              </div>
            )}
          </div>
        </div>

        {/* Delivery Block */}
       <div className="po-delivery-block">
          <div className="po-section-title">DELIVERY DETAILS</div>
          <div>
            <b>{poData?.poDetails?.office?.officeName}</b>
          </div>
          <div>
            {poData?.poDetails?.office?.address1},{" "}
            {poData?.poDetails?.office?.address2}
          </div>
          <div>{poData?.poDetails?.office?.address3}</div>
          <div>{poData?.poDetails?.office?.pincode}</div>
          <br />
          <div>
            <b>GSTIN:</b> {poData?.poDetails?.office?.gstin}
          </div>
        </div>
      </div>
    </header>
  );
};

export default PoPrintHeader;
